module.exports = __webpack_public_path__ + "img/2018-groundbreakingstadium.c25d7b6a.png";